import { defaultGrid } from "@helpers/datagrid";
import defaultReducer from "./defaultReducer";

const initialState = {
  open: false,
  ...defaultGrid,
};

export default defaultReducer("PROMO_ANALYSIS_DETAILS_MODAL", initialState);
